export const removeNonNumeric = (value) => value.replace(/\D/g, '');
